import React, { useEffect, useState } from 'react';
import { Table, Button, Drawer, Space, Popconfirm, Card, Typography, Descriptions, Segmented, Input, Row, Col, Form, Select, DatePicker, Statistic, Divider } from 'antd';

import { PlusOutlined, EditOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined, CalendarOutlined, FileTextOutlined, DatabaseOutlined, ClockCircleOutlined } from '@ant-design/icons';
import useMessage from 'antd/es/message/useMessage';
import CreateEnquiry from '../../components/Manage/Enquiry/CreateEnquiry';
import { ServicetypeService } from '../../Services/Manage/ServicetypeService';
import { EnquiryService } from '../../Services/Manage/EnquiryService';
import dayjs from 'dayjs';
import { UserService } from '../../Services/Manage/UserService';
import DashboardSummary from "./DashboardSummary";


import utc from 'dayjs/plugin/utc';
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(utc);

const EnquiryPage = () => {
  const [data, setData] = useState([]);
  const [segData, setSegData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [apiMessage, msgContext] = useMessage();
  const [generatedEQNo, setGeneratedEQNo] = useState("");
  const [value, setValue] = useState("All Enquiry");
  const [dateRange, setDateRange] = useState(null);
  const [dateFilterType, setDateFilterType] = useState("Next Follow Up");
  const [segment, setSegment] = useState("Active");
  const [searchText, setSearchText] = useState("");
  const [activeFilter, setActiveFilter] = useState({ type: 'quote', value: 'all' });



  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isBetween);

  const { Title, Text } = Typography;

  const handleSegChange = (val) => {
    setValue(val);
    if (val === "All Enquiry") {
      setData(segData);
    } else if (val === "Completed Enquiry") {
      const completed = segData.filter(
        (item) => item.eq_status.trim() === "Converted"
      );
      setData(completed)
    }
  };

  const getAllServices = async () => {
    try {
      const user = await UserService.getOmeUser();
      // const request = await EnquiryService.getAllEnquiriesById(user.uid);
      const request = await EnquiryService.getAllEnquiries();
      // const sortedData = request.data
      //   .sort((a, b) => new Date(b.eq_date) - new Date(a.eq_date)) // latest first
      //   .map((item, index) => ({
      //     ...item,
      //     si_no: index + 1,
      //     key: item.eq_id,
      //   }));

      const sortedData = request.data
        .sort((a, b) => new Date(b.eq_date) - new Date(a.eq_date))
        .map((item, index) => ({
          ...item,
          si_no: index + 1,
          key: item.eq_id,
          n_follow_up: item.enquiry_follow_up || item.n_follow_up || null,
        }));


      setSegData(sortedData);
      setData(sortedData);

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllServices();
  }, []);

  const handleExpandToggle = (record) => {
    setExpandedRowKeys((prev) =>
      prev.includes(record.eq_id)
        ? prev.filter((k) => k !== record.eq_id)
        : [...prev, record.eq_id]
    );
  };

  const handleAdd = () => {
    setEditingRecord(null);
    setDrawerOpen(true);
  };

  const handleEdit = (record) => {

    console.log(record);

    const editedRecord = {
      ...record,
      note: record.notes,
      eq_no: record.eq_id,
      n_follow_up: record.n_follow_up ? dayjs(record.n_follow_up) : null,

    };
    setEditingRecord(editedRecord);
    setDrawerOpen(true);
  };

  const handleSubmit = async (values) => {
    const user = await UserService.getOmeUser();
    const payload = { ...values, added_by: user.uid };


    console.log("payload", payload);


    if (editingRecord) {
      const edit_load = {
        ...payload,
        edit_e_id: editingRecord.e_id,
        edit_c_id: editingRecord.c_id,
      };

      console.log(edit_load);

      const request = await EnquiryService.updateEnquiries(edit_load);

      if (request.status) {
        apiMessage.success(request.message);
        getAllServices();
      } else {
        apiMessage.error(request.message);
      }
    } else {
      const request = await EnquiryService.createEnquiries(payload);

      if (request.status) {
        apiMessage.success(request.message);
        getAllServices();
      } else {
        apiMessage.error(request.message);
      }
    }
    setDrawerOpen(false);
  };

  const handleDelete = async (values) => {
    try {
      const edit_load = {
        e_id: values.e_id,
        c_id: values.c_id,
      };

      const req = await EnquiryService.deleteEnquiries(edit_load);
      if (req.status) {
        apiMessage.success(req.message);
        getAllServices();
      } else {
        apiMessage.error(req.message);
        getAllServices();
      }
    } catch (error) {
      console.error(error);
      apiMessage.error("Failed to delete enquiry");
    }
  };


  /** 🔹 Handlers */
  const handleSegmentChange = (val) => {
    setSegment(val);
    applyAllFilters(data, val, searchText, dateRange, dateFilterType);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    applyAllFilters(data, segment, value, dateRange, dateFilterType);
  };

  const handleDateRangeChange = (range) => {
    setDateRange(range);
    applyAllFilters(data, segment, searchText, range, dateFilterType);
  };

  const handleDateFilterTypeChange = (value) => {
    setDateFilterType(value);
    applyAllFilters(data, segment, searchText, dateRange, value);
  };

  const applyFollowUpDateFilter = (days) => {
    const start = dayjs().startOf("day");
    const end =
      days === 0
        ? dayjs().endOf("day")
        : dayjs().add(days, "day").endOf("day");

    const range = [start, end];

    setDateFilterType("n_follow_up");
    setDateRange(range);

    applyAllFilters(segData, searchText, range, "n_follow_up");
  };



  /** 🔹 Status counts */
  const statusCounts = data.reduce((acc, cur) => {
    const key = cur.status || "Unknown";
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const styles = {
    badge: {
      backgroundColor: "#1b1660ff",
      fontSize: 14,
      minWidth: 24,
      height: 24,
      lineHeight: "24px",
      marginLeft: 10,
    },
  };

  // const getQuickStats = (status) => {
  //   const today = dayjs();
  //   const startToday = today.startOf("day");

  //   const last7 = today.subtract(6, "day").startOf("day");
  //   const last30 = today.subtract(29, "day").startOf("day");

  //   // 👇 filter by selected status first
  //   const statusData = data.filter(
  //     d => d.status?.toLowerCase() === status.toLowerCase()
  //   );

  //   return {
  //     today: statusData.filter(d =>
  //       d.added_on && dayjs(d.added_on).isAfter(startToday)
  //     ).length,

  //     last7: statusData.filter(d =>
  //       d.added_on && dayjs(d.added_on).isAfter(last7)
  //     ).length,

  //     last30: statusData.filter(d =>
  //       d.added_on && dayjs(d.added_on).isAfter(last30)
  //     ).length,

  //     total: statusData.length,
  //   };
  // };

  const getFollowUpStats = () => {
    const source = getSegmentData(); // respects All / Completed toggle

    const todayStart = dayjs().startOf("day");
    const todayEnd = dayjs().endOf("day");
    const next7End = dayjs().add(7, "day").endOf("day");
    const next30End = dayjs().add(30, "day").endOf("day");

    const withFollowUp = source.filter(d => d.n_follow_up);

    return {
      today: withFollowUp.filter(d =>
        dayjs(d.n_follow_up).isBetween(todayStart, todayEnd, null, "[]")
      ).length,

      next7: withFollowUp.filter(d =>
        dayjs(d.n_follow_up).isAfter(todayEnd) &&
        dayjs(d.n_follow_up).isSameOrBefore(next7End)
      ).length,

      next30: withFollowUp.filter(d =>
        dayjs(d.n_follow_up).isAfter(todayEnd) &&
        dayjs(d.n_follow_up).isSameOrBefore(next30End)
      ).length,

      // ✅ this will NEVER change incorrectly now
      total: withFollowUp.length,
    };
  };



  const columns = [
    { title: 'S. No', dataIndex: 'si_no', key: 'si_no', align: 'center' },
    { title: 'Enquiry ID', dataIndex: 'eq_id', key: 'eq_id' },
    { title: 'Service', dataIndex: 'service_name', key: 'service_name' },
    { title: 'Product', dataIndex: 'product_name', key: 'product_name' },
    {
      title: 'Total Amount',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (value, record) => `${record.currency} ${value}`,
    },
    { title: 'Source', dataIndex: 'eq_source', key: 'eq_source' },
    { title: 'Status', dataIndex: 'eq_status', key: 'eq_status' },
    {
      title: 'Next Follow Up',
      dataIndex: 'enquiry_follow_up',
      key: 'enquiry_follow_up',
      render: (value) => (value ? dayjs(value).format('DD-MM-YYYY') : ''),
      // 

    },
    {
      title: 'Updated On',
      dataIndex: 'enquiry_updated_on',
      key: 'updated_on',
      render: (value) => value ? dayjs.utc(value).local().format('DD-MM-YYYY hh:mm A') : ''


    },
    {
      title: 'Actions',
      key: 'actions',
      fixed: 'right',
      render: (_, record) => (
        <Space>
          <Button
            size="large"
            icon={expandedRowKeys.includes(record.eq_id) ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            onClick={() => handleExpandToggle(record)}
          />
          <Button size="large" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
          <Popconfirm title="Are you sure to delete?" onConfirm={() => handleDelete(record)}>
            <Button size="large" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const applyAllFilters = (
    allData,
    search,
    range,
    dateType
  ) => {
    let result = [...allData];

    // 🔹 Search
    if (search) {
      const lower = search.toLowerCase();
      result = result.filter(item =>
        item.eq_id?.toLowerCase().includes(lower) ||
        item.service_name?.toLowerCase().includes(lower) ||
        item.eq_source?.toLowerCase().includes(lower) ||
        item.eq_status?.toLowerCase().includes(lower) ||
        item.name?.toLowerCase().includes(lower) ||
        item.mobile_no?.toString().includes(lower)
      );
    }

    // 🔹 Date filter
    if (range && range.length === 2 && dateType) {
      const [start, end] = range;

      result = result.filter(item => {
        const dateValue = item[dateType];
        if (!dateValue) return false;

        const d = dayjs(dateValue);
        return d.isBetween(
          start.startOf("day"),
          end.endOf("day"),
          null,
          "[]"
        );
      });
    }

    // 🔹 Sort by follow-up first, fallback to updated
    result.sort((a, b) => {
      if (a.n_follow_up && b.n_follow_up) {
        return dayjs(a.n_follow_up).diff(dayjs(b.n_follow_up));
      }
      return dayjs(b.enquiry_updated_on).diff(dayjs(a.enquiry_updated_on));
    });

    setData(result);
  };


  const expandedRowRender = (record) => (
    
    <Descriptions size="small" column={2}>
      <Descriptions.Item label="Customer Name">{record.name}</Descriptions.Item>
      <Descriptions.Item label="Customer Mobile No">{record.mobile_no}</Descriptions.Item>
      <Descriptions.Item label="Address" span={2}>{record.address}</Descriptions.Item>
      <Descriptions.Item label="Service">{record.service_name}</Descriptions.Item>
      <Descriptions.Item label="Product">{record.product_name}</Descriptions.Item>
      {/* <Descriptions.Item label="Service Type">{record.type_name}</Descriptions.Item> */}
      {/* <Descriptions.Item label="Type Code">{record.type_code}</Descriptions.Item> */}
      <Descriptions.Item label="Follow Up On">
        {record.n_follow_up ? dayjs(record.n_follow_up).format('DD-MM-YYYY') : '-'}
      </Descriptions.Item>
      <Descriptions.Item label="Note">{record.notes || '-'}</Descriptions.Item>
      {/* <Descriptions.Item label="Added By">{record.addedby}</Descriptions.Item> */}
      <Descriptions.Item label="Added On">
        {record.eq_date ? dayjs.utc(record.eq_date).local().format('DD-MM-YYYY hh:mm A') : '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Updated On">
        {record.enquiry_updated_on ? dayjs.utc(record.enquiry_updated_on).local().format('DD-MM-YYYY hh:mm A') : '-'}
      </Descriptions.Item>


    </Descriptions>
  );

  const getSegmentData = () => {
    if (value === "Completed Enquiry") {
      return segData.filter(
        (item) => item.eq_status?.trim() === "Converted"
      );
    }
    return segData;
  };

  const getStatusQuickStats = (status) => {
    const today = dayjs();
    const startToday = today.startOf("day");

    const last7 = today.subtract(6, "day").startOf("day");
    const last30 = today.subtract(29, "day").startOf("day");

    const statusData = data.filter(
      d => d.status?.toLowerCase() === status.toLowerCase()
    );

    return {
      today: statusData.filter(d =>
        d.added_on && dayjs(d.added_on).isAfter(startToday)
      ).length,
      last7: statusData.filter(d =>
        d.added_on && dayjs(d.added_on).isAfter(last7)
      ).length,
      last30: statusData.filter(d =>
        d.added_on && dayjs(d.added_on).isAfter(last30)
      ).length,
      total: statusData.length,
    };
  };

  const clearDateFilters = () => {
    setDateRange(null);
    setDateFilterType(null);
    setSearchText("");
    setActiveFilter({ type: null, value: null });

    // 🔥 reset table to FULL data
    setData(segData);
  };


  const getQuickStats = () => {
    const baseData = getSegmentData();

    const today = dayjs().startOf("day");
    const last7 = dayjs().subtract(6, "day").startOf("day");
    const last30 = dayjs().subtract(29, "day").startOf("day");

    return {
      today: baseData.filter(d =>
        d.eq_date && dayjs(d.eq_date).isAfter(today)
      ).length,

      last7: baseData.filter(d =>
        d.eq_date && dayjs(d.eq_date).isAfter(last7)
      ).length,

      last30: baseData.filter(d =>
        d.eq_date && dayjs(d.eq_date).isAfter(last30)
      ).length,

      total: baseData.length,
    };
  };

  const applyQuickDateFilter = (days) => {
    const end = dayjs();
    const start =
      days === 0
        ? end.startOf("day")
        : end.subtract(days - 1, "day").startOf("day");

    const range = [start, end];

    setDateFilterType("eq_date");
    setDateRange(range);

    applyAllFilters(segData, searchText, range, "eq_date");
  };


  const quickStats = getQuickStats(segment);

  const followUpStats = getFollowUpStats(segment);


  return (
    <Card
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          Manage Enquiries
        </Typography.Title>
      }

      extra={
        <Button size="large" type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Create Enquiry
        </Button>
      }
    >

       <div
        style={{
          maxHeight: "70vh", // adjust as needed
          overflowY: "auto",
          paddingRight: 8, // avoids scrollbar overlap
        }}
      >
      <div style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'center' }}>
        <Segmented
          size="large"
          block
          value={value}
          onChange={handleSegChange}
          options={["All Enquiry", "Completed Enquiry"]}
          style={{
            color: '#255353ff',
            width: '50%',
            padding: '6px',
          }}
        />
      </div>

      <DashboardSummary
        quickStats={quickStats}
        followUpStats={followUpStats}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        applyQuickDateFilter={applyQuickDateFilter}
        applyFollowUpDateFilter={applyFollowUpDateFilter}
        clearDateFilters={clearDateFilters}
      />

      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Search" layout="vertical">
            <Input
              allowClear
              placeholder="Search Enquiries..."
              size="large"
              onChange={(e) => applyAllFilters(e.target.value)}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Select Service" layout="vertical">
            <Select
              allowClear
              placeholder="Select Service"
              options={[
                ...[...new Set(segData.map((item) => item.service_name))].map((service) => ({
                  label: service,
                  value: service,
                })),
              ]}
              size="large"
              style={{ width: "100%" }}
              onChange={(value) => applyAllFilters("", value)}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Date Filter" layout="vertical">
            <Space.Compact block>
              <Select
                allowClear
                placeholder="Date filter type"
                value={dateFilterType}
                onChange={(val) => {
                  setDateFilterType(val);
                  applyAllFilters("", "", dateRange, val);
                }}
                style={{ width: 200 }}
                options={[
                  { label: "Next Follow Up Date", value: "Next Follow Up" },
                  { label: "Added On", value: "eq_date" },
                  { label: "Updated On", value: "enquiry_updated_on" }

                ]}
                size="large"
              />
              <DatePicker.RangePicker
                size="large"
                value={dateRange}
                onChange={(range) => {
                  setDateRange(range);
                  applyAllFilters("", "", range, dateFilterType);
                }}
                format="DD-MM-YYYY"
              />
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>

      {/* Enquiry Table */}
      <Table
        columns={columns}
        dataSource={data}
        pagination={true}
        expandable={{
          expandedRowRender,
          expandedRowKeys,
          onExpandedRowsChange: setExpandedRowKeys,
          expandIcon: () => null,
        }}
        scroll={{ x: 'max-content' }}
      />

      {msgContext}
      <Drawer
        title={
          <Space align="center">
            <Title level={4} style={{ margin: 0 }}>
              {editingRecord ? 'Edit Enquiry' : 'Add Enquiry'}
            </Title>
            <Text
              strong
              style={{
                color: 'darkviolet',
                fontSize: '1.1rem',
                padding: '2px 8px',
                background: '#f3e8ff',
                borderRadius: '8px',
                fontWeight: 700,
              }}
            >
              {editingRecord ? editingRecord.eq_id : generatedEQNo}
            </Text>
          </Space>
        }
        width={1000}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        destroyOnClose
      >
        <CreateEnquiry
          initialValues={editingRecord}
          onSubmit={handleSubmit}
          onCancel={() => setDrawerOpen(false)}
          handleEQNo={setGeneratedEQNo}
        />
      </Drawer>

        </div>
    </Card>
  );
};

export default EnquiryPage;